import { createFileRoute, Outlet } from "@tanstack/react-router";

/** The adjustments: the queue and the rest, and one adjustment's page. */
export const Route = createFileRoute("/_app/money/adjustments")({
  component: Outlet,
});
